import { gql } from 'apollo-boost';

export const GET_FOLDER_PUBLISH_STATUS = gql`
    query getFolderPublishStatus($folderId: ID!) {
        getFolderPublishStatus(folderId: $folderId) {
            token
            url
            discoverable
            linkRole
            allowAnonymousContributions
            allowCopy
            viewCount
            createdAt
        }
    }
`;
